import { AuditLogAction } from "@myapp/contract";

export const auditLogActionLabels: Record<AuditLogAction, string> = {
  WORK_ORDER_CREATED: 'Auftrag erfasst',
  WORK_ORDER_STATUS_CHANGED: 'Auftrag aktualisiert',
  WORK_ORDER_COMPLETED: 'Auftrag abgeschlossen',
  APPOINTMENT_CREATED: 'Termin geplant',
  APPOINTMENT_UPDATED: 'Termin bearbeitet',
  APPOINTMENT_RESCHEDULED: 'Termin umgeplant',
  APPOINTMENT_TECHNICIAN_CHANGED: 'Techniker geändert',
  APPOINTMENT_STARTED: 'Arbeit gestartet',
  APPOINTMENT_COMPLETED: 'Termin abgeschlossen',
  APPOINTMENT_FOLLOW_UP_REQUESTED: 'Folgetermin erforderlich',
  APPOINTMENT_EXPIRED: 'Termin abgelaufen',
  TASK_RESCHEDULED: 'Aufgabe umgeplant',
};
